import React from "react";
import { Link } from "react-router-dom";
import { Col, Row, Divider, Breadcrumb } from "antd";
import { LogoutOutlined } from "@ant-design/icons";
import { XBreadcrumb, XHeaderContainer } from "./HeaderStyle";
import HeaderTop from "./HeaderTop";

const Header = (props) => {
  return (
    <>
      <XHeaderContainer fluid>
        <Row align="middle" gutter={[15, 15]}>
          <Col xs={6} sm={6} md={6}></Col>
          <Col
            xs={24}
            sm={24}
            md={24}
            lg={12}
            className="text-center d-none d-lg-block"
          ></Col>
          <Col xs={18} sm={18} md={6} className="text-end">
            <HeaderTop />
          </Col>
        </Row>
      </XHeaderContainer>
    </>
  );
};

export default Header;
